import { useMemo } from 'react';

import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

import { useRiskManagementDetails } from '../../../hooks/use-risk-management-details/use-risk-management-details';
import { ASSET_COLUMNS_DEFS } from '../asset-table.constants';

export const useDevicesEnabledColumns = () => {
  const [isFenrirV2FeatureEnabled] = useFeatureFlag('ADS_FENRIR_V2');
  const [fullMockFF] = useFeatureFlag('ADS_FULL_MOCKED');
  const { isRisksAvailableInUP } = useRiskManagementDetails();
  const selectedColumns = useMemo(() => {
    const columns = Object.values(ASSET_COLUMNS_DEFS);
    const hiddenColumns: string[] = [];
    if (!fullMockFF) hiddenColumns.push(ASSET_COLUMNS_DEFS.OS_TYPE);
    if (isRisksAvailableInUP) hiddenColumns.push(ASSET_COLUMNS_DEFS.RISK_SCORE);
    if (!isFenrirV2FeatureEnabled)
      hiddenColumns.push(
        ASSET_COLUMNS_DEFS.OPERATING_SYSTEM,
        ASSET_COLUMNS_DEFS.MAC,
        ASSET_COLUMNS_DEFS.IP_ADDRESS,
        ASSET_COLUMNS_DEFS.OS_TYPE,
        ASSET_COLUMNS_DEFS.NETBIOS,
        ASSET_COLUMNS_DEFS.HOSTNAME,
      );
    return columns.filter((col) => !hiddenColumns.includes(col));
  }, [fullMockFF, isFenrirV2FeatureEnabled, isRisksAvailableInUP]);

  return selectedColumns;
};
